<template>
    <div>
        <slot :select="() => $refs.selectAvatar.click()" :remove="() => remove()" :thumbnail="thumbnail"></slot>
        <div :id="id" ref="selectAvatar"></div>
        <v-avatar-cropper
            :upload-handler="uploadAvatar" :trigger="`#${id}`" output-mime='image/jpeg'
            :labels='{submit: "Save",cancel: "Cancel"}' :output-quality="0.8"
            :cropper-options="{aspectRatio: 1,autoCropArea: 1,viewMode: 1,movable: false,zoomable: true}"
        />
    </div>
</template>
<script>
    import store from "./register-store";

    export default {
        props: {
            value: {},
        },
        data: v => ({
            thumbnail: null,
            id : 'select-avatar-' + Date.now(),
        }),
        methods: {
            uploadAvatar(cropper) {
                let dataUrl = cropper.getCroppedCanvas().toDataURL(null);

                this.thumbnail = dataUrl;

                var arr = dataUrl.split(","),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);

                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }

                let value = new File([u8arr], 'avatar.jpg', {type: mime});

                this.$emit('input', value)
            },
            remove() {
                console.log('remove avatar')
                this.thumbnail = null;
                this.$emit('input', null);
            }
        }
    }
</script>
